import { Button, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

export interface MenuSource {
  id: string;
  designId: string;
  name: string;
  alias?: string;
  thumbUrl?: string;
  publishedAt?: string;
  connected: boolean;
}

interface Props {
  menu: MenuSource;
  publishing?: boolean;
  onOpenDesign: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onConnect: () => void;
}

export function MenuSourceTile({
  menu,
  publishing,
  onOpenDesign,
  onEdit,
  onDelete,
  onConnect,
}: Props) {
  const title = menu.alias || menu.name;

  return (
    <div className="menu-row">
      <div className="menu-row-media">
        <button
          type="button"
          className="menu-row-thumb-btn"
          onClick={onOpenDesign}
          aria-label={`Open ${menu.name} in the editor`}
          title="Open in editor"
        >
          {menu.thumbUrl ? (
            <img src={menu.thumbUrl} alt={menu.name} />
          ) : (
            <div className="menu-row-thumb-placeholder" />
          )}
        </button>

        <div className="menu-row-actions">
          <Tooltip title="Edit">
            <button
              type="button"
              className="menu-row-action"
              aria-label="Edit"
              onClick={onEdit}
            >
              <EditOutlined />
            </button>
          </Tooltip>
          <Tooltip title="Delete">
            <button
              type="button"
              className="menu-row-action"
              aria-label="Delete"
              onClick={onDelete}
            >
              <DeleteOutlined />
            </button>
          </Tooltip>
        </div>
      </div>

      <div className="menu-row-info">
        <span
          className={`menu-conn-badge${menu.connected ? " connected" : ""}`}
        >
          <span className="menu-conn-dot" />
          {menu.connected ? "CONNECTED" : "NOT CONNECTED"}
        </span>
        <div className="menu-row-title">{title}</div>
        {menu.alias && (
          <div className="menu-row-design">Design: {menu.name}</div>
        )}
        {menu.publishedAt && (
          <div className="menu-row-date">Published {menu.publishedAt}</div>
        )}
        {menu.connected && (
          <div className="menu-row-hint">
            Changes go live when you publish this design in the editor.
          </div>
        )}
      </div>

      {(!menu.connected || publishing) && (
        <div className="menu-row-toggle">
          <Button type="primary" loading={publishing} onClick={onConnect}>
            {publishing ? "Publishing" : "Connect"}
          </Button>
        </div>
      )}
    </div>
  );
}
